import BangerLogotype from "assets/icons/banger/logo.svg?react";
import GloryLogotype from "assets/icons/glory/glory.svg?react";
import classNames from "classnames";
import CoinStrikeLandingContentContainer from "containers/molecules/CoinStrikeLandingContentContainer";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setType } from "redux/landing/wheels/slice";
import { WheelType } from "types/Wheel";
import url from "url/index";
import { SEO } from "utils/helmet/components/SEO";

import "./styles.sass";

const CointStrike = () => {
  const dispatch = useDispatch();
  const { VITE_APP_PROJECT_NAME } = import.meta.env;
  const isBanger = VITE_APP_PROJECT_NAME === "banger";

  useEffect(() => {
    dispatch(setType(WheelType.COIN_STRIKE));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const CoinStrikeLogoWrapper = classNames("CoinStrike__logo_wrapper", {
    // eslint-disable-next-line camelcase
    CoinStrike__logo_wrapper_banger: isBanger,
  });

  return (
    <>
      <SEO
        pathname={`/${url.config.landing.root}/${url.config.landing.cointStrike}`}
      />
      <div className="CoinStrike">
        <div className={CoinStrikeLogoWrapper}>
          {isBanger ? <BangerLogotype /> : <GloryLogotype />}
        </div>
        <div className="CoinStrike__image CoinStrike__image_minor" />
        <div className="CoinStrike__image CoinStrike__image_collect" />
        <div className="CoinStrike__image CoinStrike__image_grand" />
        <div className="CoinStrike__image CoinStrike__image_major" />
        <div className="CoinStrike__image CoinStrike__image_mini" />
        <div className="CoinStrike__image CoinStrike__image_grape" />
        <div className="CoinStrike__image CoinStrike__image_orange" />
        <div className="CoinStrike__image CoinStrike__image_lemon" />
        <div className="CoinStrike__image_animation_pulse">
          <div className="CoinStrike__image CoinStrike__image_bar" />
        </div>
        <CoinStrikeLandingContentContainer />
      </div>
    </>
  );
};

export default CointStrike;
